import { render } from "./VotesResultChart.vue?vue&type=template&id=434c2107"
import script from "./VotesResultChart.vue?vue&type=script&lang=js"
export * from "./VotesResultChart.vue?vue&type=script&lang=js"
script.render = render

export default script